/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
    UserDelegable,
    UserDelegableFromJSON,
    UserDelegableFromJSONTyped,
    UserDelegableToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserDelegablesListResponse
 */
export interface UserDelegablesListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof UserDelegablesListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<UserDelegable>}
     * @memberof UserDelegablesListResponse
     */
    entries: Array<UserDelegable>;
}

export function UserDelegablesListResponseFromJSON(json: any): UserDelegablesListResponse {
    return UserDelegablesListResponseFromJSONTyped(json, false);
}

export function UserDelegablesListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDelegablesListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(UserDelegableFromJSON)),
    };
}

export function UserDelegablesListResponseToJSON(value?: UserDelegablesListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(UserDelegableToJSON)),
    };
}


